import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mm-request-view" }
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = {
  key: 0,
  class: "success-message"
}
const _hoisted_4 = {
  key: 1,
  class: "error-message"
}
const _hoisted_5 = { class: "form-section" }
const _hoisted_6 = { class: "form-row" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-row" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-section" }
const _hoisted_13 = { class: "form-row" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-section" }
const _hoisted_17 = { class: "form-row" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { value: "" }
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 0,
  class: "form-group"
}
const _hoisted_25 = { class: "form-section" }
const _hoisted_26 = { class: "acknowledge-label" }
const _hoisted_27 = { class: "form-actions" }
const _hoisted_28 = ["disabled"]

import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useSchools } from '@/composables/useSchools'

interface Teacher {
  id: string
  first_name: string
  last_name: string
  email: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MattermostRequestView',
  setup(__props) {

/* eslint-disable no-undef */
const { schools, loadSchools } = useSchools()

const formData = ref({
  first_name: '',
  last_name: '',
  grade_level: '',
  student_email: '',
  parent_name: '',
  parent_email: '',
  school: '',
  teacher_email: '',
  acknowledged: false
})

const teachers = ref<Teacher[]>([])
const selectedTeacher = ref('')
const loadingTeachers = ref(false)
const showEmailInput = ref(true)
const submitting = ref(false)
const successMessage = ref('')
const errorMessage = ref('')

const loadTeachers = async (schoolId: string) => {
  if (!schoolId || schoolId === 'other') {
    teachers.value = []
    return
  }
  loadingTeachers.value = true
  try {
    const response = await axios.get(`/api/v1/schools/${schoolId}/teachers`)
    teachers.value = response.data
  } catch (error) {
    console.error('Error loading teachers:', error)
    teachers.value = []
  } finally {
    loadingTeachers.value = false
  }
}

const onSchoolChange = () => {
  selectedTeacher.value = ''
  formData.value.teacher_email = ''
  showEmailInput.value = true
  if (formData.value.school && formData.value.school !== 'other') {
    loadTeachers(formData.value.school)
  } else {
    teachers.value = []
  }
}

const onTeacherSelect = () => {
  if (selectedTeacher.value && selectedTeacher.value !== 'other') {
    const teacher = teachers.value.find(t => t.id === selectedTeacher.value)
    if (teacher) {
      formData.value.teacher_email = teacher.email
      showEmailInput.value = false
    }
  } else {
    formData.value.teacher_email = ''
    showEmailInput.value = true
  }
}

const submitRequest = async () => {
  submitting.value = true
  errorMessage.value = ''
  successMessage.value = ''

  try {
    const response = await axios.post('/api/v1/mattermost/request', formData.value)
    successMessage.value = response.data.message
      || 'Thanks! Your request has been submitted. We will contact your teacher to verify and follow up by email.'

    formData.value = {
      first_name: '',
      last_name: '',
      grade_level: '',
      student_email: '',
      parent_name: '',
      parent_email: '',
      school: '',
      teacher_email: '',
      acknowledged: false
    }
    selectedTeacher.value = ''
    window.scrollTo({ top: 0, behavior: 'smooth' })
  } catch (error: any) {
    console.error('Error submitting Mattermost request:', error)
    errorMessage.value = error.response?.data?.detail || 'Failed to submit request. Please try again.'
  } finally {
    submitting.value = false
  }
}

onMounted(() => {
  loadSchools()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "form-header" }, [
        _createElementVNode("img", {
          src: "/assets/img/logos/mattermost.png",
          alt: "Mattermost logo",
          class: "header-logo"
        }),
        _createElementVNode("h1", null, "Request to Join Mattermost"),
        _createElementVNode("p", null, "Fill out the form below and a Space Coast STEM admin will verify your request with your teacher")
      ], -1)),
      (successMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(successMessage.value), 1))
        : _createCommentVNode("", true),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true),
      (!successMessage.value)
        ? (_openBlock(), _createElementBlock("form", {
            key: 2,
            onSubmit: _withModifiers(submitRequest, ["prevent"]),
            class: "mm-form"
          }, [
            _createElementVNode("section", _hoisted_5, [
              _cache[15] || (_cache[15] = _createElementVNode("h2", null, "Your Information", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { for: "first_name" }, "First Name *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "first_name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.first_name) = $event)),
                    type: "text",
                    required: "",
                    placeholder: "First name"
                  }, null, 512), [
                    [_vModelText, formData.value.first_name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { for: "last_name" }, "Last Name *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "last_name",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.last_name) = $event)),
                    type: "text",
                    required: "",
                    placeholder: "Last name"
                  }, null, 512), [
                    [_vModelText, formData.value.last_name]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { for: "grade_level" }, "Grade Level *", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "grade_level",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.grade_level) = $event)),
                    required: ""
                  }, [...(_cache[12] || (_cache[12] = [
                    _createStaticVNode("<option value=\"\" data-v-3f9b85a4>Select grade level...</option><option value=\"4th\" data-v-3f9b85a4>4th</option><option value=\"5th\" data-v-3f9b85a4>5th</option><option value=\"6th\" data-v-3f9b85a4>6th</option><option value=\"7th\" data-v-3f9b85a4>7th</option><option value=\"8th\" data-v-3f9b85a4>8th</option><option value=\"9th\" data-v-3f9b85a4>9th</option><option value=\"10th\" data-v-3f9b85a4>10th</option><option value=\"11th\" data-v-3f9b85a4>11th</option><option value=\"12th\" data-v-3f9b85a4>12th</option>", 10)
                  ]))], 512), [
                    [_vModelSelect, formData.value.grade_level]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { for: "student_email" }, "Your Email *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "student_email",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.student_email) = $event)),
                    type: "email",
                    required: "",
                    placeholder: "your-email@example.com"
                  }, null, 512), [
                    [_vModelText, formData.value.student_email]
                  ])
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_12, [
              _cache[18] || (_cache[18] = _createElementVNode("h2", null, "Parent / Guardian", -1)),
              _cache[19] || (_cache[19] = _createElementVNode("p", { class: "section-description" }, " We require a parent or guardian on file. They will receive a notification about this request. ", -1)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { for: "parent_name" }, "Parent/Guardian Name *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "parent_name",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.parent_name) = $event)),
                    type: "text",
                    required: "",
                    placeholder: "Full name"
                  }, null, 512), [
                    [_vModelText, formData.value.parent_name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { for: "parent_email" }, "Parent/Guardian Email *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "parent_email",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.parent_email) = $event)),
                    type: "email",
                    required: "",
                    placeholder: "parent-email@example.com"
                  }, null, 512), [
                    [_vModelText, formData.value.parent_email]
                  ])
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_16, [
              _cache[26] || (_cache[26] = _createElementVNode("h2", null, "Teacher Verification", -1)),
              _cache[27] || (_cache[27] = _createElementVNode("p", { class: "section-description" }, " Provide the email of a teacher who can confirm you are a current student. We'll reach out to them before approving your account. ", -1)),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { for: "school" }, "School *", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "school",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.school) = $event)),
                    required: "",
                    onChange: onSchoolChange
                  }, [
                    _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, "-- Select School --", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schools), (school) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: school.id,
                        value: school.id
                      }, _toDisplayString(school.name), 9, _hoisted_19))
                    }), 128)),
                    _cache[21] || (_cache[21] = _createElementVNode("option", { value: "other" }, "Other", -1))
                  ], 544), [
                    [_vModelSelect, formData.value.school]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { for: "teacher_select" }, "Teacher", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "teacher_select",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedTeacher).value = $event)),
                    disabled: !formData.value.school || formData.value.school === 'other' || loadingTeachers.value,
                    onChange: onTeacherSelect
                  }, [
                    _createElementVNode("option", _hoisted_22, _toDisplayString(loadingTeachers.value ? 'Loading teachers...' : '-- Select Teacher or Enter Email Below --'), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teachers.value, (teacher) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: teacher.id,
                        value: teacher.id
                      }, _toDisplayString(teacher.first_name.charAt(0)) + ". " + _toDisplayString(teacher.last_name), 9, _hoisted_23))
                    }), 128)),
                    _cache[23] || (_cache[23] = _createElementVNode("option", { value: "other" }, "Other (enter email below)", -1))
                  ], 40, _hoisted_21), [
                    [_vModelSelect, selectedTeacher.value]
                  ])
                ])
              ]),
              (showEmailInput.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _cache[25] || (_cache[25] = _createElementVNode("label", { for: "teacher_email" }, "Teacher's Email *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "teacher_email",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.teacher_email) = $event)),
                      type: "email",
                      required: "",
                      placeholder: "teacher@school.edu"
                    }, null, 512), [
                      [_vModelText, formData.value.teacher_email]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("section", _hoisted_25, [
              _cache[29] || (_cache[29] = _createElementVNode("h2", null, "Acknowledgement", -1)),
              _createElementVNode("label", _hoisted_26, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.acknowledged) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelCheckbox, formData.value.acknowledged]
                ]),
                _cache[28] || (_cache[28] = _createElementVNode("span", null, " I understand that Mattermost is monitored, that there is a zero-tolerance policy for bullying, and that my parent/guardian may review my activity at any time. ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                type: "submit",
                disabled: submitting.value || !formData.value.acknowledged,
                class: "btn-submit"
              }, _toDisplayString(submitting.value ? 'Submitting...' : 'Submit Request'), 9, _hoisted_28)
            ])
          ], 32))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})